import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HomeComponent } from "./home/home.component";
import { HomeRouting } from "./home-routing.module";
import { NgxTypedJsModule } from "ngx-typed-js";
import { HomeAboutComponent } from "./home/home-about/home-about.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { CountUpModule } from "ngx-countup";
import { HomeSkillsComponent } from "./home/home-skills/home-skills.component";
import { HomeExperienceComponent } from "./home/home-experience/home-experience.component";
import { HomeProjectsComponent } from "./home/home-projects/home-projects.component";
import { HomeAchievementsComponent } from "./home/home-achievements/home-achievements.component";
import { HomeContactComponent } from "./home/home-contact/home-contact.component";
import { HomeExtracurricularComponent } from "./home/home-extracurricular/home-extracurricular.component";

@NgModule({
  declarations: [
    HomeComponent,
    HomeAboutComponent,
    HomeSkillsComponent,
    HomeExperienceComponent,
    HomeProjectsComponent,
    HomeAchievementsComponent,
    HomeContactComponent,
    HomeExtracurricularComponent,
  ],
  imports: [
    CommonModule,
    HomeRouting,
    NgxTypedJsModule,
    FontAwesomeModule,
    CountUpModule,
  ],
})
export class HomeModule {}
